import { Map, Record, List } from 'immutable';

const struct = {
  id:              undefined,
  name:            undefined,
  content:         undefined,
  type:            undefined,
  subType:         undefined,
  locale:          undefined,
  whatsappTokens:  new List(),
  latestAudit:     new Map(),
  settings:        new Map(),
  linkedCampaigns: new List(),
};

export default class TemplateRecord extends Record(struct, 'TemplateRecord') {

}
